
<nz-modal
	[(nzVisible)]="deleteModal"
	(nzOnCancel)="deleteModal = false"
	(nzOnOk)="onDelete()"
	[nzTitle]="'common_deletion' | translate"
	[nzContent]="'common_delete-one' | translate"
	[nzOkLoading]="deleting"
></nz-modal>
<form nz-form
      class="text-translated-form w-100"
      *ngIf="form"
      [formGroup]="form"
      (ngSubmit)="onSubmit()"
      [nzAutoTips]="explainErrorsService.autoTips">
    <nz-affix>
        <div class="py-4 border-bottom bg-white">
            <div class="container">
                <div class="row">
                    <div class="col-12 d-flex align-items-center justify-content-between">
            			<!-- Title -->
            			<div>
            				<h1 class="mb-0">
            					<span *ngIf="textTranslated.isNew()">{{ 'text-translated_create-form-title' | translate }}</span>
            					<span *ngIf="!textTranslated.isNew()">{{ textTranslated.getLabel() }}</span>
            				</h1>
            				<small *ngIf="!textTranslated.isNew()" class="text-black-50">{{ 'common_id' | translate: { id : textTranslated.getId() } }}</small>
            			</div>
            			<!-- /Title -->
            			
            			<!-- Actions -->
            			<div>
            				<button
            					nz-button
            					[disabled]="form.invalid"
            					[nzLoading]="saving"
            					nzType="primary"
                                *appRestrictedByScope="{
                                    model: 'text_translated',
                                    action: 'update'
                                }"
            				>
            					{{ 'common_save' | translate }}
            				</button>
                            <ng-container *appRestrictedByScope="{
                                model: 'text_translated',
                                action: 'delete'
                            }">
                                <button
                                    *ngIf="!textTranslated.isNew() && deletable"
                                    class="ml-4"
                                    nz-button
                                    nzShape="circle"
                                    [title]="'common_delete' | translate"
                                    [nzLoading]="deleting"
                                    (click)="deleteModal = true"
                                    type="button"
                                >
                                    <i nz-icon nzType="delete"></i>
                                </button>
                            </ng-container>
            			</div>
            			<!-- /Actions -->
            		</div>
            	</div>
            </div>
        </div>
    </nz-affix>
    <div class="container">
    <nz-card class="round-border my-5">
    <div *ngIf="loading" class="row">
        <div class="col-12">
            <nz-skeleton class="no-header" [nzActive]="true"></nz-skeleton>
        </div>
    </div>
    <div *ngIf="!loading">
        <div class="row" *ngIf="!readOnly">
            <div class="col-12 col-md-6">
                <!-- Name -->

                
                <nz-form-item>
                    <h4>{{ 'text-translated_name' | translate }}</h4>
                    <nz-form-control>

             
                        <input nz-input
                               class="w-100"
                               type="text"
                               [placeholder]="'common_value-string' | translate"
                               formControlName="name">
                    </nz-form-control>
                </nz-form-item>
                <!-- /Name -->
            </div>
            <div class="col-12 col-md-6">
                <!-- Text -->

                
                <nz-form-item>
                    <h4>{{ 'text-translated_text' | translate }}</h4>
                    <nz-form-control>

             
                        <input nz-input
                               class="w-100"
                               type="text"
                               [placeholder]="'common_value-string' | translate"
                               formControlName="text">
                    </nz-form-control>
                </nz-form-item>
                <!-- /Text -->
            </div>
            <div class="col-12 col-md-6">
                <!-- Lang -->

                
                <nz-form-item>
                    <h4>{{ 'text-translated_lang' | translate }}</h4>
                    <nz-form-control [nzValidateStatus]="form.get('lang')">

             
                        <hpf-language-select
                            [controlName]="'lang'"
                            [formGroup]="form"
                            [quickFormEnabled]="quickFormEnabled"
                            [(model)]="textTranslated.props.lang"
                            [filterEnabled]="true"
                            [placeholder]="'language_common_search-placeholder' | translate"
                            [emptyLabel]="'common_empty' | translate">
                        </hpf-language-select>
                    </nz-form-control>
                </nz-form-item>
                <!-- /Lang -->
            </div>
        </div>

        <nz-divider *ngIf="!textTranslated.isNew() && !readOnly"></nz-divider>
        <div *ngIf="!textTranslated.isNew()" class="row">
            <div class="col-12 col-md-6" >
                <!-- _Id -->
                <div class="mb-4">
                    <h4>{{ 'text-translated_-id' | translate }}</h4>
                    <div>{{ textTranslated.props._id }}</div>
                </div>
                <!-- /_Id -->
            </div>
            <div class="col-12 col-md-6" >
                <!-- Created At -->
                <div class="mb-4">
                    <h4>{{ 'text-translated_created-at' | translate }}</h4>
                    <div>{{ textTranslated.props.created_at | date:'medium' }}</div>
                </div>
                <!-- /Created At -->
            </div>
            <div class="col-12 col-md-6" >
                <!-- Owner -->
                <div class="mb-4">
                    <h4>{{ 'text-translated_owner' | translate }}</h4>
                    <div *ngIf="textTranslated.ownerExists()">
                        <a [routerLink]="['/user', textTranslated.props.owner.getId()]">
                            {{ textTranslated.props.owner.getLabel() }}
                        </a>
                    </div>
                </div>
                <!-- /Owner -->
            </div>
            <div class="col-12 col-md-6" *ngIf="readOnly">
                <!-- Name -->
                <div class="mb-4">
                    <h4>{{ 'text-translated_name' | translate }}</h4>
                    <div>{{ textTranslated.props.name }}</div>
                </div>
                <!-- /Name -->
            </div>
            <div class="col-12 col-md-6" *ngIf="readOnly">
                <!-- Text -->
                <div class="mb-4">
                    <h4>{{ 'text-translated_text' | translate }}</h4>
                    <div>{{ textTranslated.props.text }}</div>
                </div>
                <!-- /Text -->
            </div>
            <div class="col-12 col-md-6" *ngIf="readOnly">
                <!-- Lang -->
                <div class="mb-4">
                    <h4>{{ 'text-translated_lang' | translate }}</h4>
                    <div *ngIf="textTranslated.langExists()">
                        <a [routerLink]="['/language', textTranslated.props.lang.getId()]">
                            {{ textTranslated.props.lang.getLabel() }}
                        </a>
                    </div>
                </div>
                <!-- /Lang -->
            </div>
        </div>
    </div>
    </nz-card>
    </div>
</form>
